<script lang="ts">
    import { getKirbyPage } from "../../api/kirby/api"
    import { spaLink } from "../../functionTools/routing"
    import { lang } from "../../store"
    import AnimatingMoreArrow from "./AnimatingMoreArrow.svelte"

    let {
        text,
        path,
        page_ref,
        type = "white",
        size = "small",
        reverseArrow = false,
        align = "center",
        shiftRight = false,
        target = "_self",
    }: {
        text: string
        path?: string
        page_ref?: string
        type?: "white" | "dark"
        size?: "small" | "big"
        reverseArrow?: boolean
        align?: "top" | "center"
        shiftRight?: boolean
        target?: "_blank" | "_self"
    } = $props()
    if (page_ref) {
        getKirbyPage(page_ref, {
            url: true,
        }).then((page) => {
            if (!page) return
            path = `/${$lang}/` + page.url.split(`/${$lang}/`).pop()
        })
    }
    let active = $state(false)
    if (!target) target = "_self"
</script>

<a
    href={path}
    use:spaLink
    {target}
    class:reverseArrow
    class="morebtn more {type} {size} {align}"
    onclick={(e) => {
        e.stopPropagation()
    }}
    onmouseenter={() => (active = true)}
    onmouseleave={() => (active = false)}
>
    {#if reverseArrow}
        <AnimatingMoreArrow {active} color={type} reverseArrow={true} />
    {/if}
    <span>{text}</span>
    {#if !reverseArrow}
        <AnimatingMoreArrow {active} color={type} {shiftRight} />
    {/if}
</a>

<style lang="less" global>
    .morebtn {
        height: 30px;
        &.more {
            display: flex;
            align-items: center;
            gap: 12px;
            font-size: 0.7rem;
            &.white {
                color: var(--bright-100);
            }

            &.dark {
                color: var(--dark-100);
            }

            &:hover {
                color: var(--brand-100);
            }

            &.big {
                font-size: 1rem;
                height: unset;
            }
            &.top {
                align-items: flex-start;
            }
            &.small {
                span {
                    font-size: 0.7rem;
                }
            }
        }
        span {
            // no word wrap
        }
        &.reverseArrow {
            span {
                color: var(--dark-100, #242220);
                font-size: 1rem;
                font-weight: 700;
                text-transform: uppercase;
            }
        }
    }
</style>
